/**
* Content Accordion JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Accordion component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'content-accordion',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.faq-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '#' + $( event.target ).attr( 'aria-controls' ) ).slideToggle();
      } );

      $( '.content-accordion' ).each( function( key, val ) {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: '.content-accordion .container',
            start: 'top 75%',
            end: 'bottom top',
            scrub: 0,
            onEnter: ( x, y, z ) => {
              $( '.content-accordion__line' ).addClass( 'is-loaded' );
            },
            // markers: true,
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'content-accordion', COMPONENT );
} )( app );
